//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from "../pureForm/FMPSelect";

const options = [
	{ value : 'previousMonthRollOver', display : 'Rollover from Previous Month', },
	{ value : 'interTankTransfer', display : 'Inter Tank Transfer', },
	{ value : 'other', display : 'Other', },
];

class FMPAllocationReasonPicker extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, disabled,
			contained
		} = this.props;

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				md={md}
				helpText={helpText}
				disabled={disabled}
				contained={contained}
			/>
		);
	}
}

FMPAllocationReasonPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
	productTypes : PropTypes.array,
	disabled : PropTypes.bool,

	dataDumpMap : PropTypes.object,
	contained : PropTypes.bool,
};

FMPAllocationReasonPicker.defaultProps =  {
	md : 12,
	label : 'Allocation Reason',
};

export default FMPAllocationReasonPicker;
